import { ProductsHero } from '@/components/products/ProductsHero'
import { ProductsCatalog } from '@/components/products/ProductsCatalog'
import { ProductsHowToOrder } from '@/components/products/ProductsHowToOrder'

export const ProductsPage = () => (
  <>
    <ProductsHero />
    <ProductsCatalog />
    <ProductsHowToOrder />
  </>
)
